import React from "react";

/**
 * Stride mark: two forward chevrons suggesting continuous progress.
 */
export function Logo({ size = 28, tone = "dark", className = "" }) {
  const orange = "#F05A28";
  const base = tone === "light" ? "#FFFFFF" : "#0F172A";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Stride"
      role="img"
    >
      <path d="M7 7l8 9-8 9" stroke={base} strokeWidth="3.6" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <path d="M18 7l8 9-8 9" stroke={orange} strokeWidth="3.6" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </svg>
  );
}

export default Logo;
